import { create } from 'zustand';
import db from '../../db';

export const useOperatorStore = create((set) => ({
  operatorId: null,
  name: null, // Add name property

  setOperatorID: async (id, name) => {
    await db.operator.put({ key: 'operatorId', value: id });
    await db.operator.put({ key: 'name', value: name }); // Store name in the database
    set({ operatorId: id, name }); // Update state with id and name
  },

  clearOperatorID: async () => {
    await db.operator.clear();
    set({ operatorId: null, name: null }); // Clear both id and name
  },

  /** Load last selected operator from IndexedDB (e.g. after page refresh). */
  rehydrate: async () => {
    try {
      const idRecord = await db.operator.get('operatorId');
      const nameRecord = await db.operator.get('name');
      if (idRecord?.value != null) {
        set({
          operatorId: idRecord.value,
          name: nameRecord?.value ?? null,
        });
      }
    } catch (e) {
      console.warn('Operator rehydrate failed:', e);
    }
  },
}));
